import { Produktionsstatus } from "~app/common/models/constants";
import { IProduktionsstatusFilter } from "./IProduktionsstatusFilter";

export class ProduktionsstatusFilter implements IProduktionsstatusFilter {
    produktionsstatus: string[];
    maskinlag: boolean[];
    produkter: boolean[];
    destinerad: boolean[];
    drivningspunkter: boolean[];

    constructor() {
        this.produktionsstatus = [];
        this.initFields();
    }

    hasDisabledStatus(): boolean {
        return this.produktionsstatus.indexOf(Produktionsstatus.ProduktionEjPaborjad) === -1;
    }

    statusChanged() {
        if (this.hasDisabledStatus()) {
            this.initFields();
        }
    }

    private initFields() {
        this.maskinlag = [];
        this.produkter = [];
        this.destinerad = [];
        this.drivningspunkter = [];
    }
}
